import { Game } from '@/constants/game.const';

/**
 * Maps a PandaScore videogame slug to the app's Game enum. PandaScore uses
 * slugs like `cs-go` / `dota-2`; we keep a few aliases for safety.
 */
const VIDEOGAME_SLUG_TO_GAME: Record<string, Game> = {
  'cs-go': Game.CS2,
  csgo: Game.CS2,
  cs2: Game.CS2,
  'dota-2': Game.DOTA,
  dota2: Game.DOTA,
};

export const getGameFromVideogameSlug = (
  slug?: string | null
): Game | null => (slug ? (VIDEOGAME_SLUG_TO_GAME[slug] ?? null) : null);

export const GAME_LABEL: Record<Game, string> = {
  [Game.CS2]: 'CS2',
  [Game.DOTA]: 'Dota 2',
};
